import { connect } from 'react-redux';
import {
  addOrRule,
  updateOrRule,
  deleteOrRule,
} from '@store/filterContainer/actions';
import { createSelector } from 'reselect';
import { selector as commonSelector } from '@store/common';
import { selector as filterContainerSelector } from '@store/filterContainer';
import FilterRow from './FilterRow';


const selector = createSelector(
  commonSelector,
  filterContainerSelector,
  (common, filterStore) => ({
    features: common.features,
    andRules: filterStore.newFilterPanel.rule,
  }),
);


export default connect(
  selector,
  {
    clickOR: addOrRule,
    deleteRule: deleteOrRule,
    onRuleChange: updateOrRule,
  },
)(FilterRow);
